module.exports = "/img/6.7693dd.webp";